<template>
  <div class="unternehmen mb-n4">
    <v-row :class="$vuetify.breakpoint.smAndUp ? 'space-between' : ''"
           no-gutters>

      <v-col v-if="isUsed('name')" cols="12"
             sm="6">
        <v-text-field v-model="name"
                      v-validate="{ required: true, max: 120 }"
                      v-dmb-trim
                      :error-messages="errors.collect('companyname')"
                      data-vv-as="Firmenname"
                      class="required"
                      name="companyname"
                      label="Firmenname" />
      </v-col>

      <v-col v-if="isUsed('rechtsform')"
             cols="12"
             sm="6">
        <dmb-autocomplete v-model="rechtsform"
                        v-validate="{ required: true }"
                        :error-messages="errors.collect('rechtsform')"
                        :items="rechtsformList"
                        :disabled="isDisabled('rechtsform')"
                        :auto-select-index="1"
                        always-show-value="0000"
                        item-text="name"
                        item-value="code"
                        data-vv-as="Rechtsform"
                        data-vv-name="rechtsform"
                        :class="isDisabled('rechtsform') ? 'noclass' : 'required'"
                        :name="random123('rechtsform')"
                        label="Rechtsform" />
      </v-col>

      <template v-if="isUsed('branche')">
        <v-col v-if="!isDisabled('branche') || brancheCode !== '0000'"
               cols="12"
               sm="6">
          <v-row no-gutters
                 align="center"
                 class="flex-nowrap mb-4">
            <dmb-autocomplete v-model="brancheCode"
                            v-validate="{ required: true }"
                            :error-messages="errors.collect('branche')"
                            :items="branchenList"
                            :disabled="isDisabled('branche')"
                            :auto-select-index="1"
                            always-show-value="0000"
                            item-text="name"
                            item-value="code"
                            data-vv-as="Branche"
                            data-vv-name="branche"
                            class="isDisabled('branche') ? 'mb-0 mr-1' : 'mb-0 mr-1 required'"
                            :name="random123('branche')"
                            label="Branche"
                            @change="setBranche($event)" />
            <site-tooltip v-if="!isDisabled('branche')"
                          titel="Branchen">
              Bitte beachten Sie, dass für bestimmte Branchen nur ausgewählte Rechtsschutz-Angebote möglich sind.<br/>
              Bei Fragen rufen Sie gerne die Makler-Hotline unter (+49) 02 21 / 37 638 - 92 an.
            </site-tooltip>
          </v-row>
        </v-col>

        <v-col v-if="brancheCode === '0000'"
               cols="12"
               sm="6">
          <v-text-field v-model="brancheName"
                        v-validate="{ required: true }"
                        v-dmb-trim
                        :error-messages="errors.collect('branche2')"
                        :disabled="isDisabled('branche')"
                        data-vv-as="Branche"
                        class="required"
                        name="branche2"
                        label="Sonstige Branche" />
        </v-col>
      </template>

      <template v-if="isUsed('adresse')">

        <v-col cols="12"
               sm="6">
          <v-text-field v-model="strasse"
                        v-validate="{ required: true, regex: /^[^!§$%&\/()=?#*+{\[\]}]*$/ }"
                        v-dmb-trim
                        :error-messages="errors.collect('strasse')"
                        data-vv-as="Straße"
                        class="required"
                        name="strasse"
                        label="Straße" />
        </v-col>

        <v-col cols="12"
               sm="6">
          <v-text-field v-model="hausnummer"
                        v-validate="{ required: true, regex: /^[1-9][0-9a-zA-Z-\/,]*$/ }"
                        v-dmb-trim
                        :error-messages="errors.collect('hausnummer')"
                        data-vv-as="Hausnummer"
                        class="required"
                        name="hausnummer"
                        label="Hausnummer"
                        @change="restrictHausnummer" />
        </v-col>

        <v-col cols="12"
               sm="6">
          <v-text-field v-model="adresszusatz"
                        v-dmb-trim
                        data-vv-as="Adresszusatz"
                        name="adresszusatz"
                        label="Adresszusatz" />
        </v-col><v-col cols="0" sm="6"/>

        <v-col cols="12"
               sm="6">
          <v-text-field v-model="plz"
                        v-validate="{ required: true,
                                      numeric: isDE,
                                      min: isDE ? 5 : 0,
                                      max: isDE ? 5: 12
                                    }"
                        v-dmb-trim
                        :error-messages="errors.collect('plz')"
                        data-vv-as="Postleitzahl"
                        class="required"
                        name="plz"
                        label="Postleitzahl"
                        @input="onInputPlz" />
        </v-col>

        <v-col cols="12"
               sm="6">
          <v-text-field v-if="!isDE || cityList.length === 0"
                        v-model="ort"
                        v-dmb-trim
                        v-validate="{ required: true, regex: regex.ort }"
                        :error-messages="errors.collect('ort')"
                        data-vv-as="Ort"
                        class="required"
                        name="ort"
                        label="Ort" />
          <v-combobox v-else
                      v-model="ort"
                      v-dmb-trim
                      v-validate="{ required: true, regex: regex.ort }"
                      :error-messages="errors.collect('ort')"
                      :items="cityList"
                      data-vv-as="Ort"
                      name="ort"
                      class="required"
                      label="Ort" />
        </v-col>

        <v-col cols="12"
               sm="6">
          <dmb-autocomplete v-model="staat"
                          v-validate="'required'"
                          :error-messages="errors.collect('staat')"
                          :items="countryList"
                          item-text="name"
                          item-value="name"
                          auto-select-first
                          data-vv-as="Land"
                          data-vv-name="staat"
                          class="required"
                          :name="random123('staat')"
                          label="Land" />
        </v-col><v-col cols="0" sm="6"/>

      </template>

      <template v-if="isUsed('kontakt')">
        <v-col cols="12"
               sm="6">
          <v-text-field v-model="email"
                        v-validate="'email'"
                        v-dmb-trim
                        :error-messages="errors.collect('email')"
                        data-vv-as="E-Mail Adresse"
                        name="email"
                        label="E-Mail" />
        </v-col>

        <v-col cols="12"
               sm="6">
          <v-text-field v-model="telefon"
                        v-validate="{regex: regex.telefon }"
                        v-dmb-trim
                        :error-messages="errors.collect('telefon')"
                        data-vv-as="Festnetz- / Mobilnummer"
                        name="telefon"
                        label="Festnetz- / Mobilnummer" />
        </v-col>

      </template>

      <template v-if="isUsed('hr')">

        <v-col cols="12"
               sm="6">
          <v-select v-model="handelsregister"
                          v-validate="'required'"
                          :error-messages="errors.collect('handelsregister')"
                          :items="hrList"
                          disable-lookup
                          auto-select-first
                          data-vv-as="Handelsregister"
                          data-vv-name="handelsregister"
                          class="required"
                          name="handelsregister"
                          label="Handelsregister"
                          @change="hrnummer = (handelsregister == 'kein Handelsregistereintrag') ? '' : hrnummer" />
        </v-col>

        <v-col cols="12"
               sm="6">
          <v-text-field v-if="handelsregister == 'kein Handelsregistereintrag' ? false : true"
                        v-model="hrnummer"
                        v-validate="'required|min:5|max:15'"
                        v-dmb-trim
                        :error-messages="errors.collect('hrnummer')"
                        data-vv-as="HR-Nummer"
                        name="hrnummer"
                        class="required"
                        label="HR-Nummer" />
        </v-col>

      </template>

    </v-row>
  </div>
</template>

<script>
import ValidationMixin from "@/components/helper/ValidationMixin";
import twowayBindingMixin, { mapTwoWay } from '../../store/twowayBindingMixin';
import plzOrtMixin from "@/components/helper/plzOrtMixin";
import branchen from '../../store/config/gewerbeBranchen';
import rechtsform from '../../store/config/companyLegalform';
import countries from "@/store/config/countries";
import REGEX from "@/validation/regexes";

export default {
  mixins: [ twowayBindingMixin, ValidationMixin, plzOrtMixin ],
  props: {
    unused: {
      type: Array,
      required: false,
      default: () => []
    },
    disabled: {
      type: Array,
      required: false,
      default: () => []
    },
    resetBranchen: {
      type: Array,
      required: false,
      default: () => []
    },
    resetRechtsformen: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data: function () {
    return {
      rechtsformList: rechtsform.legalformList.concat([rechtsform.other]),
      branchenList: branchen.branchenList(),
      countryList: countries.countryCodes,
      hrList: [
        'Handelsregister Abteilung A',
        'Handelsregister Abteilung B',
        'kein Handelsregistereintrag'
      ],
      regex: REGEX
    };
  },
  computed: {
    ...mapTwoWay([
      'brancheCode',
      'brancheName',
      'name',
      'rechtsform',
      'strasse',
      'hausnummer',
      'adresszusatz',
      'plz',
      'ort',
      'staat',
      'email',
      'telefon',
      'handelsregister',
      'hrnummer'
    ],    
    {
      brancheCode: 'branche.code',
      brancheName: 'branche.name'
    }),
    isDE() {
      return this.staat === 'Deutschland';
    }
  },
  watch: {
    resetBranchen(value) {
      // timeout triggers UI update
      if (value.indexOf(this.brancheCode) > -1) {
        setTimeout(() => this.brancheCode = null, 0);
      }
    },
    resetRechtsformen(value) {
      // timeout triggers UI update
      if (value.indexOf(this.rechtsform) > -1) {
        setTimeout(() => this.rechtsform = null, 0);
      }
    }
  },
  methods: {
    isUsed(field) {
      return !(this.unused.includes(field));
    },
    isDisabled(field) {
      return this.disabled.includes(field);
    },
    setBranche() {
      if (this.brancheCode === '0000') {
        this.brancheName = null;
      } else {
        const branche = this.branchenList.find(b => b.code === this.brancheCode);
        if (branche) this.brancheName = branche.name;
      }
    },
    restrictHausnummer() { 
      this.hausnummer = this.hausnummer.replace(/[^0-9a-zA-Z-/,]/g, ""); //on blur change
    }
  }
};
</script>

<style>
  .v-list-item {
    min-height: 36px !important; /* overwrite vuetify from 48px */
  }
  .v-list-item__content{
    padding-bottom: 8px;  /* overwrite vuetify from 12px */
    padding-top: 8px;
  }
  .unternehmen .v-input--is-disabled .v-input__icon--append{
    visibility: hidden !important; /* hide dropdown button if control is disabled */
  }
</style>

